import { Component, OnInit } from '@angular/core';
import { ButtercmssdkService } from '../../../../services/buttercmssdk.service';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html'
})
export class MainPageComponent implements OnInit {

  public pageData = {
    "seo": {
      "title": "TechEnClutch Solutions",
      "description": "TechEnClutch Solutions"
    },
    "body": [
      {
        "type": "hero",
        "fields": {
          "headline": "TechEnClutch Solutions",
          "subheadline": "We specialize in providing technology-driven solutions to help businesses and individuals manage, store, process, and utilize information efficiently.",
          "image": "https://cdn.buttercms.com/RwE6eNYBTFa7G15zEiuj",
          "scroll_anchor_id": "home"
        }
      },
      {
        "type": "two_column_with_image",
        "fields": {
          "headline": "About Us",
          "subheadline": "We are a team of tech enthusiasts, problem-solvers, and creative thinkers with a shared commitment to excellence. With expertise spanning software development, IT consulting, cloud computing, and cybersecurity, we pride ourselves on staying ahead of the curve in an ever-evolving digital landscape.",
          "image": "https://cdn.buttercms.com/08PFKQISL2Agb6RufT2A",
          "image_position": "left",
          "scroll_anchor_id": "about"
        }
      },
      {
        "type": "features",
        "fields": {
          "headline": "Services We Offer",
          "subheadline": "At TechEnClutch Solutions, we provide a comprehensive range of IT solutions designed to empower your business and drive success in today’s competitive digital landscape. Our services are tailored to meet the unique needs of businesses of all sizes, ensuring innovation, efficiency, and reliability in everything we deliver.",
          "scroll_anchor_id": "features",
          "features": [
            {
              "headline": "Web and Mobile App Development",
              "description": "Build your online presence with stunning websites and user-friendly mobile apps. Our team specializes in creating responsive, engaging, and feature-rich digital experiences that resonate with your audience.",
              "icon": "https://cdn.buttercms.com/hWC1eXQLyYZKE4h03CLQ"
            },
            {
              "headline": "IT Consulting",
              "description": "Leverage our expertise to create a robust IT strategy. We provide insights and guidance to help you adopt emerging technologies, optimize operations, and align your IT infrastructure with your business objectives.",
              "icon": "https://cdn.buttercms.com/zwL5xPiR8yFbSYYG6kgr"
            },
            {
              "headline": "Managed IT Services",
              "description": "Focus on your core business while we handle your IT operations. From system monitoring to technical support, we ensure your technology runs smoothly and efficiently.",
              "icon": "https://cdn.buttercms.com/UrvV7047TridMZx0RpOc"
            },
            {
              "headline": "Data Analytics and Business Intelligence",
              "description": "Turn data into actionable insights with our analytics and BI solutions. We help you make data-driven decisions that boost efficiency, identify opportunities, and drive growth.",
              "icon": "https://cdn.buttercms.com/epLAKeLUSv6xJekCA3NT"
            }
          ]
        }
      },
      // {
      //   "type": "two_column_with_image",
      //   "fields": {
      //     "headline": "Customize this page",
      //     "subheadline": "<p>Try updating the content of this page to reflect your own. You can also explore modifying these components or creating your own in your Butter dashboard.  Learn more about <a href=\"https://buttercms.com/kb/creating-editing-and-deleting-pages-and-page-types\">Page Types</a> and <a href=\"https://buttercms.com/kb/how-to-modify-components\">Components</a>.</p>",
      //     "image": "https://cdn.buttercms.com/VXI3trZuRx2dnaHOVqKb",
      //     "image_position": "right",
      //     "button_label": "Update this Page in Butter",
      //     "button_url": "https://buttercms.com/pages/",
      //     "scroll_anchor_id": "tryit"
      //   }
      // },
      // {
      //   "type": "testimonials",
      //   "fields": {
      //     "headline": "What our customers say",
      //     "scroll_anchor_id": "testimonials",
      //     "testimonial": [
      //       {
      //         "quote": "Super Flexible CMS Solution",
      //         "name": "Hampton Catlin",
      //         "title": "Creator of Sass and Haml"
      //       },
      //       {
      //         "quote": "A breath of fresh air in the CMS world, once you go headless with butter you'll never go back.",
      //         "name": "Bryan MacMillan",
      //         "title": "IT Admin"
      //       },
      //       {
      //         "quote": "I was able to quickly draft new pages, circulate them to the team, edit them, and then ultimately publish intuitively.",
      //         "name": "Kim Kohatsu",
      //         "title": "CMO"
      //       }
      //     ]
      //   }
      // }
    ]
  };
  public posts;

  constructor(private bCMSSDKService: ButtercmssdkService,
    private route: ActivatedRoute,
    public meta: Meta,
    public title: Title) {
  }

  ngOnInit(): void {
    const slug = this.route.snapshot.params.slug;
    // this.bCMSSDKService.getButterCMS().page.retrieve('landing-page', slug?.length ? slug : 'landing-page-with-components')
    //   .then(res => {
    //     this.pageData = res.data.data.fields;

    // this.title.setTitle("TechEnClutch");
    this.meta.addTag({ name: 'description', content: "TechEnClutch" });

    //     setTimeout(() => {
    //       const f = this.route.snapshot.fragment;
    //       const element = document.querySelector('#' + f);
    //       if (element) {
    //         element.scrollIntoView();
    //       }
    //     }, 500);
    //   })
    //   .catch(_ => this.bCMSSDKService.navigateToNotFound());

    // this.bCMSSDKService.getButterCMS().post.list({page: 1, page_size: 2})
    //   .then(res => this.posts = res)
    //   .catch(_ => this.bCMSSDKService.navigateToNotFound());
  }

}
